//@ts-check
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Routes from './core/routes/routes';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import store from './core/redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Routes />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
